const Roles = {
    pcSkeletonContainer: 'pcSkeletonContainer',
    pcContainer: 'pcContainer',
    projectCard: 'projectCard',
    createProjectCard: 'createProjectCard',
    createProjectDialogue: 'createProjectDialogue',
    editProjectDialogue: 'editProjectDialogue',
    userSelect: 'userSelect',
    projectNameTxt: 'projectNameTxt',
    closeModalBtn: 'closeModalBtn',
    userMenuItem: 'userMenuItem',
};

export default Roles;
